import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PaymentTermsAndConditionsComponent } from 'libs/ui/src/lib/payment-terms-and-conditions/payment-terms-and-conditions.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { modalMapKeyTypes } from './custom-modal.type';
import { SelectOrganizationComponent } from 'libs/ui/src/lib/select-organization/select-organization.component';
import { NewCustomMaterialComponent } from 'libs/ui/src/lib/new-custom-material/new-custom-material.component';
import { CustomCopyComponent } from 'libs/ui/src/lib/custom-copy/custom-copy.component';
import { CustomDeleteComponent } from 'libs/ui/src/lib/custom-delete/custom-delete.component';
import { MyOrganizationDeleteComponent } from 'libs/ui/src/lib/my-organization-delete/my-organization-delete.component';
import { NewCustomConversionComponent } from 'libs/ui/src/lib/new-custom-conversion/new-custom-conversion.component';
import { NewCustomFillingComponent } from 'libs/ui/src/lib/new-custom-filling/new-custom-filling.component';
import { NewCustomStorageComponent } from 'libs/ui/src/lib/new-custom-storage/new-custom-storage.component';
import { NewWasteScenarioComponent } from 'libs/ui/src/lib/new-waste-scenario/new-waste-scenario.component';
import { NewCustomTruckComponent } from 'libs/ui/src/lib/new-custom-truck/new-custom-truck.component';
import { NewCustomTransportScenarioComponent } from 'libs/ui/src/lib/new-custom-transport-scenario/new-custom-transport-scenario.component';
import { NewCustomReuseComponent } from 'libs/ui/src/lib/new-custom-reuse/new-custom-reuse.component';
import { NewMyOrganizationManageUserComponent } from 'libs/ui/src/lib/new-my-organization-manage-user/new-my-organization-manage-user.component';
import { NewMyTeamsComponent } from 'libs/ui/src/lib/new-my-teams/new-my-teams.component';
import { NewManageProductGroupsComponent } from 'libs/ui/src/lib/new-manage-product-groups/new-manage-product-groups.component';
import { NewManageProjectWorkflowComponent } from 'libs/ui/src/lib/new-manage-project-workflow/new-manage-project-workflow.component';
import { NewManageScenarioWorkflowComponent } from 'libs/ui/src/lib/new-manage-scenario-workflow/new-manage-scenario-workflow.component';
import { AddEditSsoGroupComponent } from 'libs/ui/src/lib/add-edit-sso-group/add-edit-sso-group.component';
import { ListOfSuppliersComponent } from 'libs/ui/src/lib/list-of-suppliers/list-of-suppliers.component';
import { EditOrganizationYearEndComponent } from 'libs/ui/src/lib/edit-organization-year-end/edit-organization-year-end.component';
import { EditCustomSpeedosComponent } from 'libs/ui/src/lib/edit-custom-speedos/edit-custom-speedos.component';
import { CustomPackagingMetricsComponent } from 'libs/ui/src/lib/custom-packaging-metrics/custom-packaging-metrics.component';
import { CustomCategoryComponent } from 'libs/ui/src/lib/custom-category/custom-category.component';
import { EditLitterImpactComponent } from 'libs/ui/src/lib/edit-litter-impact/edit-litter-impact.component';
import { AdminLoginLogsHistoryComponent } from 'libs/ui/src/lib/admin-login-logs-history/admin-login-logs-history.component';
import { NewAdminOrganizationComponent } from 'libs/ui/src/lib/new-admin-organization/new-admin-organization.component';
import { NewProcessingConversionComponent } from 'libs/ui/src/lib/new-processing-conversion/new-processing-conversion.component';
import { NewOrganizationMembershipComponent } from 'libs/ui/src/lib/new-organization-membership/new-organization-membership.component';
import { AddMaterialsComponent } from 'libs/ui/src/lib/add-materials/add-materials.component';
import { AddIngredientsComponent } from 'libs/ui/src/lib/add-ingredients/add-ingredients.component';
import { AddRecycledMaterialComponent } from 'libs/ui/src/lib/add-recycled-material/add-recycled-material.component';
import { NewAreaBasedConversionComponent } from 'libs/ui/src/lib/new-area-based-conversion/new-area-based-conversion.component';
import { NewEnergyAndAncillaryComponent } from 'libs/ui/src/lib/new-energy-and-ancillary/new-energy-and-ancillary.component';
import { NewAdminProcessingTransportComponent } from 'libs/ui/src/lib/new-admin-processing-transport/new-admin-processing-transport.component';
import { NewProcessingCustomConversionComponent } from 'libs/ui/src/lib/new-processing-custom-conversion/new-processing-custom-conversion.component';
import { NewUsersTeamMembershipComponent } from 'libs/ui/src/lib/new-users-team-membership/new-users-team-membership.component';
import { AddTeamTeamMembershipComponent } from 'libs/ui/src/lib/add-team-team-membership/add-team-team-membership.component';
import { ProcessingStorageComponent } from 'libs/ui/src/lib/processing-storage/processing-storage.component';
import { NewProcessingWasteComponent } from 'libs/ui/src/lib/new-processing-waste/new-processing-waste.component';
import { NewRefrigeratedTruckComponent } from 'libs/ui/src/lib/new-refrigerated-truck/new-refrigerated-truck.component';
import { NewProcessingCustomTruckComponent } from 'libs/ui/src/lib/new-processing-custom-truck/new-processing-custom-truck.component';
import { AddEolComponent } from 'libs/ui/src/lib/add-eol/add-eol.component';
import { NewOtherDataMaterialComponent } from 'libs/ui/src/lib/new-other-data-material/new-other-data-material.component';
import { NewCircularEconomyParameterComponent } from 'libs/ui/src/lib/new-circular-economy-parameter/new-circular-economy-parameter.component';
import { NewPalletTypeComponent } from 'libs/ui/src/lib/new-pallet-type/new-pallet-type.component';
import { NewProjectStatusComponent } from 'libs/ui/src/lib/new-project-status/new-project-status.component';
import { NewEquivalancyUnitsComponent } from 'libs/ui/src/lib/new-equivalancy-units/new-equivalancy-units.component';
import { ConversionMappingComponent } from 'libs/features/src/lib/layout/administrator/data-management/eol-data/conversion-mapping/conversion-mapping.component';
import { AddConversionMappingComponent } from 'libs/ui/src/lib/add-conversion-mapping/add-conversion-mapping.component';
import { AddRecycledContentComponent } from 'libs/ui/src/lib/add-recycled-content/add-recycled-content.component';
import { NewCountryIndetifiersComponent } from 'libs/ui/src/lib/new-country-indetifiers/new-country-indetifiers.component';
import { ProductPackagingRatioComponent } from 'libs/features/src/lib/layout/administrator/data-management/eol-data/product-packaging-ratio/product-packaging-ratio.component';
import { AddProductPackagingRatioComponent } from 'libs/ui/src/lib/add-product-packaging-ratio/add-product-packaging-ratio.component';
import { NewAdminMiscSimulationComponent } from 'libs/ui/src/lib/new-admin-misc-simulation/new-admin-misc-simulation.component';
import { NewViewLogEntriesComponent } from 'libs/ui/src/lib/new-view-log-entries/new-view-log-entries.component';
import { AddCountryComponent } from 'libs/ui/src/lib/add-country/add-country.component';
import { NewMyProjectsComponent } from 'libs/ui/src/lib/new-my-projects/new-my-projects.component';
import { AddStateComponent } from 'libs/ui/src/lib/add-state/add-state.component';
import { AddCityComponent } from 'libs/ui/src/lib/add-city/add-city.component';
import { AddAdminNewsComponent } from 'libs/ui/src/lib/add-admin-news/add-admin-news.component';
import { NewMyProjectCopyComponent } from 'libs/ui/src/lib/new-my-project-copy/new-my-project-copy.component';
import { AddRoleComponent } from 'libs/ui/src/lib/add-role/add-role.component';
import { InvoiceDataModalComponent } from 'libs/ui/src/lib/invoice-data-modal/invoice-data-modal.component';
import { NewAddProjectScenarioComponent } from 'libs/ui/src/lib/new-add-project-scenario/new-add-project-scenario.component';
import { TermsAndConditionsComponent } from 'libs/ui/src/lib/terms-and-conditions/terms-and-conditions.component';
import { NewProjectMaterialComponent } from 'libs/ui/src/lib/new-project-material/new-project-material.component';
import { openNewAddProjectManufactureModal } from '@piqet-angular/data';
import { NewAddProjectScenarioManufacturingComponent } from 'libs/ui/src/lib/new-add-project-scenario-manufacturing/new-add-project-scenario-manufacturing.component';
import { NewAddProjectScenarioFillDataComponent } from 'libs/ui/src/lib/new-add-project-scenario-fill-data/new-add-project-scenario-fill-data.component';
import { NewAddProjectScenarioWholesaleDataComponent } from 'libs/ui/src/lib/new-add-project-scenario-wholesale-data/new-add-project-scenario-wholesale-data.component';
import { UploadImportComponent } from 'libs/ui/src/lib/upload-import/upload-import.component';
import { CopyProjectScenarioComponent } from 'libs/ui/src/lib/copy-project-scenario/copy-project-scenario.component';
import { CopyReportTemplateComponent } from 'libs/ui/src/lib/copy-report-template/copy-report-template.component';
import { NewProjectMaterialCopyComponent } from 'libs/ui/src/lib/new-project-material-copy/new-project-material-copy.component';
import { NewProjectScenarioRetailComponent } from 'libs/ui/src/lib/new-project-scenario-retail/new-project-scenario-retail.component';
import { ForceChangePasswordComponent } from 'libs/features/src/lib/force-change-password/force-change-password.component';
import { ProjectPalletConfigurationComponent } from 'libs/ui/src/lib/project-pallet-configuration/project-pallet-configuration.component';
import { NewProductProjectComponent } from 'libs/ui/src/lib/new-product-project/new-product-project.component';
import { NewProductIngredientComponent } from 'libs/ui/src/lib/new-product-ingredient/new-product-ingredient.component';
import { NewEolPreRetailComponent } from 'libs/ui/src/lib/new-eol-pre-retail/new-eol-pre-retail.component';
import { AddPackagingContentConfigurationComponent } from 'libs/ui/src/lib/add-packaging-content-configuration/add-packaging-content-configuration.component';
import { AddSkuDataComponent } from 'libs/ui/src/lib/add-sku-data/add-sku-data.component';
import { AddProductUseImpactComponent } from 'libs/ui/src/lib/add-product-use-impact/add-product-use-impact.component';
import { AddProductEolComponent } from 'libs/ui/src/lib/add-product-eol/add-product-eol.component';
import { SelectNewProjectComponent } from 'libs/ui/src/lib/select-new-project/select-new-project.component';
import { AddProductUseComponent } from 'libs/ui/src/lib/add-product-use/add-product-use.component';
import { ReportBugComponent } from 'libs/ui/src/lib/report-bug/report-bug.component';
import { AdminCopyOrganizationComponent } from 'libs/ui/src/lib/admin-copy-organization/admin-copy-organization.component';
import { AdditionalInfoNewsComponent } from 'libs/ui/src/lib/additional-info-news/additional-info-news.component';
import { ReportShareComponent } from 'libs/ui/src/lib/report-share/report-share.component';
import { HistoryDetailsComponent } from 'libs/ui/src/lib/history-details/history-details.component';
import { InstructionsComponent } from '../instructions/instructions.component';
import { ImportNewProjectMaterialComponent } from 'libs/ui/src/lib/import-new-project-material/import-new-project-material.component';
import { ImportProjectPalletConfigurationComponent } from 'libs/ui/src/lib/import-project-pallet-configuration/import-project-pallet-configuration.component';
import { ExcleTemplateInfoComponent } from 'libs/ui/src/lib/excle-template-info/excle-template-info.component';
import { NewAddSubProductComponent } from 'libs/ui/src/lib/new-add-sub-product/new-add-sub-product.component';
import { CopySubProductComponent } from 'libs/ui/src/lib/copy-sub-product/copy-sub-product.component';
import { NewOrganizationDataMapComponent } from 'libs/ui/src/lib/new-organization-data-map/new-organization-data-map.component';
import { AutomationWorkFlowComponent } from 'libs/ui/src/lib/automation-work-flow/automation-work-flow.component';
import { EmailTemplateEditorComponent } from 'libs/ui/src/lib/email-template-editor/email-template-editor.component';
import { TestAutomationComponent } from 'libs/ui/src/lib/test-automation/test-automation.component';
import { MailSenderComponent } from 'libs/ui/src/lib/mail-sender/mail-sender.component';
import { ImportIssueResolverComponent } from 'libs/ui/src/lib/import-issue-resolver/import-issue-resolver.component';
import { InvalidEolScenarioComponent } from 'libs/ui/src/lib/invalid-eol-scenario/invalid-eol-scenario.component';
import { ImportUsersComponent } from 'libs/features/src/lib/layout/my-organization/import-users/import-users.component';
import { ImportUserErrorComponent } from 'libs/features/src/lib/layout/my-organization/import-user-error/import-user-error.component';
import { UserActionSelectionModalComponent } from 'libs/features/src/lib/layout/my-organization/user-action-selection-modal/user-action-selection-modal.component';
import { ShareLinkModalComponent } from 'libs/features/src/lib/layout/my-organization/share-link-modal/share-link-modal.component';
import { ToolVerificationImportModalComponent } from 'libs/features/src/lib/layout/administrator/tool-verification-import-modal/tool-verification-import-modal.component';
import { CommentBoxComponent } from 'libs/ui/src/lib/comment-box/comment-box.component';
import { ImportVersionCommentComponent } from 'libs/ui/src/lib/import-version-comment/import-version-comment.component';
import { CreateSnapshotComponent } from 'libs/ui/src/lib/create-snapshot/create-snapshot.component';
import { SignupUserDetailsComponent } from 'libs/ui/src/lib/signup-user-details/signup-user-details.component';
import { AddMainProductConfigurationComponent } from 'libs/ui/src/lib/add-main-product-configuration/add-main-product-configuration.component';

@Injectable({
  providedIn: 'root',
})
export class CustomModalService {
  ref!: BsModalRef | null | any;
  isModelAlreadyOpen = false;
  private modalStack: BsModalRef[] = [];
  constructor(public modalService: BsModalService, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.closeAll();
      }
    });
  }

  modalMapper = new Map<modalMapKeyTypes, any>([
    ['paymentTermsAndCondition', PaymentTermsAndConditionsComponent],
    ['selectOrganization', SelectOrganizationComponent],
    ['newCustomMaterial', NewCustomMaterialComponent],
    ['deleteCustom', CustomDeleteComponent],
    ['copyCustom', CustomCopyComponent],
    ['myOrgDeleteModal', MyOrganizationDeleteComponent],
    ['newCustomConversion', NewCustomConversionComponent],
    ['newCustomFilling', NewCustomFillingComponent],
    ['newCustomStorage', NewCustomStorageComponent],
    ['newCustomTruck', NewCustomTruckComponent],
    ['newCustomTransportScenario', NewCustomTransportScenarioComponent],
    ['newCustomWasteScenario', NewWasteScenarioComponent],
    ['newCustomReuse', NewCustomReuseComponent],
    ['newMyOrganizationManageUser', NewMyOrganizationManageUserComponent],
    ['newMyTeams', NewMyTeamsComponent],
    ['newManageProductGroups', NewManageProductGroupsComponent],
    ['newManageProjectWorkflow', NewManageProjectWorkflowComponent],
    ['newManageScenarioWorkflow', NewManageScenarioWorkflowComponent],
    ['addEditSSOGroup', AddEditSsoGroupComponent],
    ['listOfSuppliers', ListOfSuppliersComponent],
    ['editOrgYearEnd', EditOrganizationYearEndComponent],
    ['editCustomSpeedos', EditCustomSpeedosComponent],
    ['editPackagingMetrics', CustomPackagingMetricsComponent],
    ['editCustomCategory', CustomCategoryComponent],
    ['editLitterImpact', EditLitterImpactComponent],
    ['userLoginLogs', AdminLoginLogsHistoryComponent],
    ['newAdminOrganization', NewAdminOrganizationComponent],
    ['newProcessingConversion', NewProcessingConversionComponent],
    ['newOrganizationMember', NewOrganizationMembershipComponent],
    ['newAdminMaterial', AddMaterialsComponent],
    ['newAdminIngredients', AddIngredientsComponent],
    ['newAdminRecycledMaterials', AddRecycledMaterialComponent],
    ['newAreaBasedConversion', NewAreaBasedConversionComponent],
    ['newEnergyAndAncillary', NewEnergyAndAncillaryComponent],
    ['newTransport', NewAdminProcessingTransportComponent],
    ['newProcessingCustomConversion', NewProcessingCustomConversionComponent],
    ['newUsersTeamMembership', NewUsersTeamMembershipComponent],
    ['addTeamTeamMembership', AddTeamTeamMembershipComponent],
    ['newProcessingStorage', ProcessingStorageComponent],
    ['newWaste', NewProcessingWasteComponent],
    ['newRefrigeratedTruck', NewRefrigeratedTruckComponent],
    ['newProcessingCustomTruck', NewProcessingCustomTruckComponent],
    ['addEolModal', AddEolComponent],
    ['newOtherMaterial', NewOtherDataMaterialComponent],
    ['newCircularEconomyParameter', NewCircularEconomyParameterComponent],
    ['newPalletType', NewPalletTypeComponent],
    ['newProjectStatus', NewProjectStatusComponent],
    ['newEquivalancyUnits', NewEquivalancyUnitsComponent],
    ['addConversionMapping', AddConversionMappingComponent],
    ['addRecycledContent', AddRecycledContentComponent],
    ['newCountryIndetifiers', NewCountryIndetifiersComponent],
    ['addProductPackagingRatio', AddProductPackagingRatioComponent],
    ['newMiscSimulation', NewAdminMiscSimulationComponent],
    ['newViewLogEntries', NewViewLogEntriesComponent],
    ['addCountry', AddCountryComponent],
    ['newMyProjects', NewMyProjectsComponent],
    ['addState', AddStateComponent],
    ['addCity', AddCityComponent],
    ['addNews', AddAdminNewsComponent],
    ['newCopyMyProjectModal', NewMyProjectCopyComponent],
    ['addRole', AddRoleComponent],
    ['getInvoiceModal', InvoiceDataModalComponent],
    ['newAddProjectScenario', NewAddProjectScenarioComponent],
    ['termsAndConditions', TermsAndConditionsComponent],
    ['newAddProjectMaterial', NewProjectMaterialComponent],
    ['newAddProjectManufacture', NewAddProjectScenarioManufacturingComponent],
    ['newAddProjectFillData', NewAddProjectScenarioFillDataComponent],
    ['newAddProjectScenarioWholesale', NewAddProjectScenarioWholesaleDataComponent],
    ['adminImport', UploadImportComponent],
    ['copyProjectScenario', CopyProjectScenarioComponent],
    ['copyReportTemplate', CopyReportTemplateComponent],
    ['newCopyPackMaterial', NewProjectMaterialCopyComponent],
    ['newAddProjectScenarioRetail', NewProjectScenarioRetailComponent],
    ['projectPalletConfig', ProjectPalletConfigurationComponent],
    ['selectAddProject', SelectNewProjectComponent],
    ['newMyProductProjects', NewProductProjectComponent],
    ['newProjectIngredient', NewProductIngredientComponent],
    ['newEolPreRetail', NewEolPreRetailComponent],
    ['packagingContentConfig', AddPackagingContentConfigurationComponent],
    ['addSKUData', AddSkuDataComponent],
    ['addProductUseImpact', AddProductUseImpactComponent],
    ['addProductEOL', AddProductEolComponent],
    ['addProdUse', AddProductUseComponent],
    ['reportBug', ReportBugComponent],
    ['adminCopyOrganization', AdminCopyOrganizationComponent],
    ['AdditionalInfoNews', AdditionalInfoNewsComponent],
    ['ReportShare', ReportShareComponent],
    ['HistoryDetails', HistoryDetailsComponent],
    ['InstructionsComponent', InstructionsComponent],
    ['importNewProjectMaterial', ImportNewProjectMaterialComponent],
    ['importProjectPalletConfig', ImportProjectPalletConfigurationComponent],
    ['ExcleTemplateInfoComponent', ExcleTemplateInfoComponent],
    ['newAddSubProduct', NewAddSubProductComponent],
    ['copySubProduct', CopySubProductComponent],
    ['NewOrganizationDataMapComponent', NewOrganizationDataMapComponent],
    ['automationWorkFlowComponent', AutomationWorkFlowComponent],
    ['emailTemplateEditorComponent', EmailTemplateEditorComponent],
    ['testAutomationWorkFlow', TestAutomationComponent],
    ['mailSenderModel', MailSenderComponent],
    ['ImportIssueResolverComponent', ImportIssueResolverComponent],
    ['invalidEolScenarioComponent', InvalidEolScenarioComponent],
    ['AddMainProductConfigurationComponent', AddMainProductConfigurationComponent],
    ['importUsersComponent', ImportUsersComponent],
    ['importUserErrorComponent', ImportUserErrorComponent],
    ['userActionSelectionModal', UserActionSelectionModalComponent],
    ['shareLinkModal', ShareLinkModalComponent],
    ['toolVerificationImport', ToolVerificationImportModalComponent],
    ['commentModel', CommentBoxComponent],
    ['importVersionComment', ImportVersionCommentComponent],
    ['createSnapshot', CreateSnapshotComponent],
    ['signupUserDetails', SignupUserDetailsComponent],
  ]);

  close() {
    if (this.ref) {
      this.ref.hide();
      this.ref = null;
    }

    // Also close the last modal from stack
    const lastModal = this.modalStack.pop();
    if (lastModal) {
      lastModal.hide();
    }

    // Reset flag if no more modals
    if (this.modalStack.length === 0) {
      this.isModelAlreadyOpen = false;
    }
  }

  closeAll() {
    // Close all modals in the stack
    this.modalStack.forEach(modal => modal.hide());
    this.modalStack = [];

    if (this.ref) {
      this.ref.hide();
      this.ref = null;
    }

    this.isModelAlreadyOpen = false;
  }

  invoke(modalName: any, modalConfig?: ModalOptions): BsModalRef | null {
    try {
      // Allow multiple modals but with proper management
      const newModalRef = this.modalService.show(this.modalMapper.get(modalName), {
        initialState: { ...modalConfig?.initialState },
        ignoreBackdropClick: true,
        backdrop: true,
        keyboard: false,
        ...modalConfig,
      });

      // Store the new modal reference
      this.ref = newModalRef;
      this.modalStack.push(newModalRef);
      this.isModelAlreadyOpen = true;

      // Listen to onHidden event to manage the stack
      newModalRef.onHidden?.subscribe(() => {
        // Remove this modal from the stack
        const index = this.modalStack.indexOf(newModalRef);
        if (index > -1) {
          this.modalStack.splice(index, 1);
        }

        // Update the ref to the last modal in stack
        if (this.modalStack.length > 0) {
          this.ref = this.modalStack[this.modalStack.length - 1];
        } else {
          this.ref = null;
          this.isModelAlreadyOpen = false;
        }
      });

      return newModalRef;
    } catch (error) {
      console.error('Error opening modal:', error);
      return null;
    }
  }
}
